export class HomeHeaderProfileMenuConstants {

  static readonly Menu = [
    {
      labelKey: "homeHeader.profile.action.manageProfile",
      icon: "manage-profile",
      routeUrl: "/manage-profile"
    },
    {
      labelKey: "homeHeader.profile.action.accountSettings",
      icon: "account-settings",
      routeUrl: ""
    },
    {
      labelKey: "homeHeader.profile.action.helpCenter",
      icon: "help-center",
      routeUrl: ""
    },
    {
      labelKey: "homeHeader.profile.action.documentation",
      icon: "documentation",
      routeUrl: ""
    },
    {
      labelKey: "homeHeader.profile.action.security",
      icon: "security",
      routeUrl: ""
    },
    {
      labelKey: "homeHeader.profile.action.paymentAndSubscription",
      icon: "payment-and-subscription",
      routeUrl: ""
    }
  ]
}